import { GlobalReducerActions } from "./globalReducer";
import axiosInstance from "services/axiosInstance";
import { setMembersOrderStr } from "util/helpers";
import Endpoints from "constants/Endpoints";
import Tables from "constants/Tables";

const { setLoading, setNotificationMessage, setCustomedNotificationMessage } =
  GlobalReducerActions;
const { SECTION, LIST_ITEM } = Endpoints;
const { LOGOS_TABLE } = Tables;

const NEW_LOGO = {
  image: "",
  description: "",
};

const LOGOS_REDUCER_INITIAL_STATE = {
  retrievedData: false,
  data: [],
  selectedLogo: {},
  originalPositions: "",
  newPositions: "",
  newLogo: { ...NEW_LOGO },
};

export const LOGOS_REDUCER_TYPES = {
  GET_LOGOS_DATA: "GET_LOGOS_DATA",
  SET_LOGOS_DATA: "SET_LOGOS_DATA",
  GET_SELECTED_LOGO_DATA: "GET_SELECTED_LOGO_DATA",
  SET_SELECTED_LOGO_DATA: "SET_SELECTED_LOGO_DATA",
  SET_LOGOS_RETRIEVED_DATA: "SET_LOGOS_RETRIEVED_DATA",
  SET_NEW_LOGO_DATA: "SET_NEW_LOGO_DATA",
  SET_LOGOS_NEW_POSITIONS_DATA: "SET_LOGOS_NEW_POSITIONS_DATA",
};

export const logosReducer = (state = LOGOS_REDUCER_INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGOS_REDUCER_TYPES.GET_LOGOS_DATA:
      const updatedPayload = [...payload];
      updatedPayload.forEach((item) => {
        if (!item.originalPosition) {
          item.originalPosition = item.position;
        }
      });
      return {
        ...state,
        data: updatedPayload,
        originalPositions: setMembersOrderStr(updatedPayload, true),
        newPositions: setMembersOrderStr(updatedPayload, true),
      };
    case LOGOS_REDUCER_TYPES.SET_LOGOS_DATA:
      return {
        ...state,
        data: payload,
      };
    case LOGOS_REDUCER_TYPES.SET_LOGOS_NEW_POSITIONS_DATA:
      return {
        ...state,
        newPositions: payload,
      };
    case LOGOS_REDUCER_TYPES.GET_SELECTED_LOGO_DATA:
      return {
        ...state,
        selectedLogo: payload,
      };
    case LOGOS_REDUCER_TYPES.SET_SELECTED_LOGO_DATA:
      return {
        ...state,
        selectedLogo: payload,
      };
    case LOGOS_REDUCER_TYPES.SET_NEW_LOGO_DATA:
      return {
        ...state,
        newLogo: payload,
      };
    case LOGOS_REDUCER_TYPES.SET_LOGOS_RETRIEVED_DATA:
      return {
        ...state,
        retrievedData: payload,
      };
    default:
      return state;
  }
};

const getLogosData = (kit) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "get",
        url: `${SECTION}/${kit}/${LOGOS_TABLE}`,
      });
      if (response?.status === 200 && response.data) {
        dispatch({
          type: LOGOS_REDUCER_TYPES.GET_LOGOS_DATA,
          payload: response.data.item,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch({
        type: LOGOS_REDUCER_TYPES.SET_LOGOS_RETRIEVED_DATA,
        payload: true,
      });
    }
  };
};

const getSelectedLogoData = (kit, id) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "get",
        url: `${LIST_ITEM}/${kit}/${LOGOS_TABLE}/${id}`,
      });
      if (response?.status === 200 && response.data) {
        dispatch({
          type: LOGOS_REDUCER_TYPES.GET_SELECTED_LOGO_DATA,
          payload: response.data.data,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch({
        type: LOGOS_REDUCER_TYPES.SET_LOGOS_RETRIEVED_DATA,
        payload: true,
      });
    }
  };
};

const setLogosData = (payload) => {
  const sortedPositions = payload.sort((a, b) => a.position - b.position);
  return async (dispatch) => {
    try {
      dispatch({
        type: LOGOS_REDUCER_TYPES.SET_LOGOS_DATA,
        payload: sortedPositions,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const setLogosNewPositions = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOGOS_REDUCER_TYPES.SET_LOGOS_NEW_POSITIONS_DATA,
        payload,
      });
    } catch (error) {
      console.log(error);
    }
  };
};

const setSelectedLogoData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOGOS_REDUCER_TYPES.SET_SELECTED_LOGO_DATA,
        payload,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const setNewLogoData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOGOS_REDUCER_TYPES.SET_NEW_LOGO_DATA,
        payload,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const saveChanges = (kit, newData) => {
  const data = [...newData];
  data.forEach((item) => delete item.originalPosition);
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "post",
        url: SECTION,
        data: {
          kit,
          tableName: LOGOS_TABLE,
          item: data,
        },
      });
      if (response?.status === 200) {
        dispatch({
          type: LOGOS_REDUCER_TYPES.GET_LOGOS_DATA,
          payload: response.data.item,
        });
        dispatch(setNotificationMessage("default_success"));
      }
    } catch (error) {
      dispatch(setNotificationMessage("default_error"));
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };
};

const saveSelectedLogoChanges = (kit, newData) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "put",
        url: LIST_ITEM,
        data: {
          kit,
          tableName: LOGOS_TABLE,
          item: newData,
        },
      });
      if (response?.status === 200) {
        dispatch({
          type: LOGOS_REDUCER_TYPES.GET_SELECTED_LOGO_DATA,
          payload: response.data,
        });
        dispatch(setNotificationMessage("default_success"));
      }
      dispatch({
        type: LOGOS_REDUCER_TYPES.SET_LOGOS_RETRIEVED_DATA,
        payload: false,
      });
    } catch (error) {
      dispatch(setNotificationMessage("default_error"));
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };
};

const saveNewLogo = (kit, newData) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "post",
        url: LIST_ITEM,
        data: {
          kit,
          tableName: LOGOS_TABLE,
          item: newData,
        },
      });
      if (response?.status === 200) {
        dispatch({
          type: LOGOS_REDUCER_TYPES.GET_LOGOS_DATA,
          payload: response.data.item,
        });
        dispatch({
          type: LOGOS_REDUCER_TYPES.SET_NEW_LOGO_DATA,
          payload: { ...NEW_LOGO },
        });
        dispatch(
          setCustomedNotificationMessage(
            `${newData.description} has been successfully added!`
          )
        );
      }
      dispatch({
        type: LOGOS_REDUCER_TYPES.SET_LOGOS_RETRIEVED_DATA,
        payload: false,
      });
    } catch (error) {
      dispatch(setNotificationMessage("default_error"));
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };
};

const deleteLogoData = (kit, id) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "delete",
        url: LIST_ITEM,
        data: {
          kit,
          tableName: LOGOS_TABLE,
          id,
        },
      });
      if (response?.status === 200) {
        const { description } = response.data.deletedItem;
        dispatch(
          setCustomedNotificationMessage(
            `${description} has been successfuly removed!`
          )
        );
        dispatch({
          type: LOGOS_REDUCER_TYPES.GET_LOGOS_DATA,
          payload: response.data.updatedList,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const LogosReducerActions = {
  getLogosData,
  setLogosData,
  getSelectedLogoData,
  setSelectedLogoData,
  setNewLogoData,
  saveChanges,
  saveSelectedLogoChanges,
  saveNewLogo,
  deleteLogoData,
  setLogosNewPositions,
};
